export const REGULAR_EXPRESSIONS = {
  EMAIL: '^[\\w-\\.]+([+\\w-\\.])*@([\\w-]+\\.)+[\\w-]{2,}$',
  PASSWORD_SPECIAL_CHARACTERS:
    '^(?=.*[!"#$%&\'()*+,\\-./:;<=>?@\\[\\\\\\]^_`{|}~]).*$',
  PASSWORD_ONE_NUMBER: '^(?=.*\\d).*$',
  PASSWORD_ONE_LOWERCASE: '^(?=.*[a-z]).*$',
  PASSWORD_ONE_UPPERCASE: '^(?=.*[A-Z]).*$',
  NAME_LETTERS_ONLY: /^\p{L}+$/u,
};

// INFO: [min | max] metric (kg)
export const WEIGHT_VALIDATION = {
  minMax: [45, 300],
};

export const HEIGHT_VALIDATION = {
  // INFO: [min | max] metric (cm)
  minMax: [100, 250],
};

export const AGE_VALIDATION = {
  minMax: [18, 99],
};

export const NAME_VALIDATION = {
  minMax: [1, 50],
};
